export interface Permission {
  id: string;
  name: string;
  description: string;
  isInherited?: boolean; // Optional flag to indicate if permission is inherited from a parent scope
}

export interface AccessResponse {
  permissions: Permission[];
  role: string;
}

export const PermissionType = {
  Owner: 'Owner',
  Reader: 'Reader',
  Contributor: 'Contributor',
  Author: 'Author',
}

export const roles = {
  [PermissionType.Reader]: 'Reader',
  [PermissionType.Contributor]: 'Contributor',
  [PermissionType.Author]: 'Author',
  [PermissionType.Owner]: 'Owner',
};

/** Default permissions for project settings */
export const PROJECT_PERMISSIONS: Permission[] = [
  { id: PermissionType.Reader, name: 'Reader', description: 'Can only view projects, permissions, and its artifacts but cannot manage project, connections, permissions and view applications.' },
  { id: PermissionType.Author, name: 'Author', description: 'Can create and manage content like applications and artifacts within the project but cannot manage project settings, un-authored applications or permissions.' },
  { id: PermissionType.Contributor, name: 'Contributor', description: 'Full access to all project resources - applications, connections and permission management. Will still need application level permissions to manage apps.' },
];

/** Default permissions for application settings */
export const APPLICATION_PERMISSIONS: Permission[] = [
  { id: PermissionType.Reader, name: 'Reader', description: 'Can only view workflows, connections and settings but cannot manage them.' },
  { id: PermissionType.Contributor, name: 'Contributor', description: 'Full access to all application resources - create, and manage workflows, connections and app level permissions. Cannot delete application.' },
];
